var _g, _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 559,
    height: 119,
    viewBox: "0 0 559 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1332_3394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546 18.4167C546 19.488 545.682 20.5353 545.087 21.426C544.492 22.3168 543.646 23.0111 542.656 23.4211C541.666 23.831 540.577 23.9383 539.527 23.7293C538.476 23.5203 537.511 23.0044 536.753 22.2469C535.996 21.4893 535.48 20.5242 535.271 19.4734C535.062 18.4227 535.169 17.3336 535.579 16.3438C535.989 15.3541 536.683 14.5081 537.574 13.9129C538.465 13.3177 539.512 13 540.583 13C542.02 13 543.398 13.5707 544.413 14.5865C545.429 15.6024 546 16.9801 546 18.4167ZM543.095 38.3782C542.671 40.0428 542.07 41.6568 541.301 43.1925C539.88 45.8783 537.748 48.121 535.137 49.6746C532.526 51.2283 529.538 52.0328 526.5 52H524.333V41.4765C524.294 39.6828 523.564 37.9734 522.295 36.7047C521.027 35.436 519.317 34.7059 517.524 34.6667H507V32.5C506.967 29.4621 507.772 26.4738 509.325 23.863C510.879 21.2522 513.122 19.1197 515.808 17.6995C517.343 16.9304 518.957 16.3289 520.622 15.9055C528.58 5.15671 537.812 0.385708 551.326 4.14344e-05H551.417C552.423 -0.00328967 553.419 0.194263 554.348 0.581119C555.277 0.967975 556.119 1.53635 556.826 2.25293C557.532 2.96951 558.088 3.81987 558.461 4.75416C558.835 5.68846 559.018 6.68789 559 7.69388C558.61 21.4002 553.986 30.3334 543.095 38.3782ZM552.5 7.60071C552.505 7.31595 552.397 7.0408 552.2 6.8348C552.004 6.62881 551.734 6.50855 551.449 6.50004C539.617 6.85104 532.298 10.7597 525.367 20.4339C523.57 23.0072 521.972 25.714 520.587 28.5307C522.973 29.1317 525.152 30.3679 526.892 32.1079C528.632 33.8479 529.868 36.0267 530.469 38.4129C533.286 37.0287 535.993 35.4308 538.566 33.6332C548.258 26.6869 552.166 19.3895 552.5 7.60071ZM510.534 40.5774C508.857 42.25 507.823 47.3005 507.457 49.4L507 52L509.6 51.5407C511.682 51.1724 516.702 50.1345 518.379 48.4532C519.419 47.4061 520.002 45.9906 520.002 44.5153C520.002 43.04 519.419 41.6245 518.379 40.5774C517.325 39.5641 515.919 38.9981 514.457 38.9981C512.994 38.9981 511.588 39.5641 510.534 40.5774Z",
    fill: "#5200FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 103,
    r: 16,
    fill: "black",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 103,
    r: 7,
    fill: "#5200FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 104C137.667 120.5 388 118.5 500.5 57",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1332_3394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(507)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRock);
export default __webpack_public_path__ + "static/media/rock.0d23d1a030e1bd5faa0f77518a6cd670.svg";
export { ForwardRef as ReactComponent };